module.exports = __webpack_public_path__ + "static/media/hX68k9apXH34UhMZ4YbJDUZUmBx6ACtiIv50C0PO.94de3232.jpg";